import Auth from '@/auth';
import { view } from '@/helpers';

const routes = (store) => {
  return [
    {
      path: '/index.html',
      name: 'index-html',
      beforeEnter: (to, from, next) => {
        return next({ name: 'home' });
      },
    },
    {
      path: '/',
      name: 'home',
      component: view('Home/Home'),
      beforeEnter: async(to, from, next) => {
        if (!Auth.isAuthorized()) {
          await Auth.authorizeBasedOnIP();
        }

        if (!Auth.isAuthorized()) {
          return next({ name: 'login' });
        }

        return next();
      },
    },
    {
      path: '/login',
      name: 'login',
      component: view('Login'),
    },
    {
      path: '/unauthorized',
      name: 'unauthorized',
      component: view('403'),
    },
    {
      path: '*',
      component: view('404'),
    },
  ];
};

export default routes;
